module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[60]303.dc611a4.woff2";